import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { Autocomplete, TextField } from "@mui/material";
import { IDataFormasRecebimento } from "../../types/api/financeiro/pesquisar-formas-recebimento";
import {ConfiguracoesCartao} from "./SelectFormaPagamento";

export default function SelectFormaRecebimento({
    value,
    onChange,
    loja_id,
    flg_usa_receber = false,
    flg_pix_configurado = false,
    desabilitarInput = false
}: SelectSimpleApiQueryProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-formas-recebimento", loja_id, flg_usa_receber, flg_pix_configurado],
        queryFn: () => axiosClient.get("/financeiro/contas-receber/pesquisar-formas-recebimento", {
            params: {
                limit: 50,
                loja_id,
                flg_usa_receber,
                flg_pix_configurado
            }
        })
    });
    const listData: IDataFormasRecebimento[] = data?.data.data || []
    //

    return (
        <Autocomplete
            disabled={isLoading || desabilitarInput}
            id="combo-box-demo"
            value={value}
            options={listData.map((i) => ({
                label: i.nome,
                id: i.id,   
                requerNsu: i.flg_cartao_credito === "S" ? true : false,
                requerChequeInfo: i.flg_cheque === "S" ? true : false,
                requerModalPix: i.flg_usa_pix === "S" ? true : false,
                configuracoes_cartao: i.configuracoes_cartao,
                maximo_parcelas: i.maximo_parcelas
            }))}
            onChange={(_: any, newValue: TObjValueFormRecebimento | null) => {
                onChange(newValue);
            }}
            renderInput={(params) => <TextField {...params} label={isLoading ? "Carregando" : "Formas de recebimento"} fullWidth />}
            clearOnEscape
        />
    )
}

interface SelectSimpleApiQueryProps {
    value: TObjValueFormRecebimento | null
    onChange: (arg: TObjValueFormRecebimento | null) => void,
    loja_id: number,
    flg_usa_receber?: boolean
    flg_pix_configurado?: boolean
    desabilitarInput?: boolean
}

export type TObjValueFormRecebimento = {
    label: string,
    id: number,
    requerNsu: boolean,
    requerChequeInfo: boolean
    requerModalPix: boolean
    configuracoes_cartao?: ConfiguracoesCartao
    maximo_parcelas?:number;
}